module.exports = __webpack_public_path__ + "img/powered_by_stripe.467f01ab.svg";